import { useQuery } from '@tanstack/react-query';
import { useMenuAxios } from '../context/axios.js';
import { fetchCore } from '../data/query.js';

const useCoreQuery = () => {
  const {
    instance
  } = useMenuAxios();
  return useQuery({
    queryKey: ["core"],
    queryFn: () => fetchCore(instance),
    refetchInterval: 6e4
  });
};

export { useCoreQuery };
